export default __webpack_public_path__ + "static/media/trash-img.2bb14989.svg";